import { TodoData } from "../../types";

// The local calendar day of a Date as YYYY-MM-DD (never UTC).
export const ymdOf = (dt: Date) =>
  `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(
    dt.getDate(),
  ).padStart(2, "0")}`;

// Local calendar day `n` days after a YYYY-MM-DD string (never UTC).
export const addDaysLocal = (ymd: string, n: number) => {
  const [y, m, d] = ymd.split("-").map(Number);
  return ymdOf(new Date(y, m - 1, d + n));
};

// Open todo due today, tomorrow or overdue (local calendar day).
export const isDueSoon = (t: Pick<TodoData, "done" | "dueDate">, today: string) =>
  !t.done && !!t.dueDate && t.dueDate <= addDaysLocal(today, 1);

// Due-soon todos first (earliest due first), then the given sort.
export const dueFirst =
  (compare: (a: TodoData, b: TodoData) => number, today: string) =>
  (a: TodoData, b: TodoData) => {
    const aSoon = isDueSoon(a, today);
    const bSoon = isDueSoon(b, today);
    if (aSoon !== bSoon) return aSoon ? -1 : 1;
    if (aSoon && bSoon && a.dueDate !== b.dueDate) return a.dueDate! < b.dueDate! ? -1 : 1;
    return compare(a, b);
  };

// `locale` defaults to the runtime's; it is only passed to pin output in tests.
// Returns "" for a malformed or impossible date so the UI never shows "Invalid Date".
export const formatDueDate = (ymd: string, locale?: string) => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(ymd)) return "";
  const [y, m, d] = ymd.split("-").map(Number);
  const dt = new Date(y, m - 1, d);
  // Impossible dates (e.g. 2026-02-31) roll over; reject them.
  if (dt.getFullYear() !== y || dt.getMonth() !== m - 1 || dt.getDate() !== d) return "";
  return dt.toLocaleDateString(locale, { month: "short", day: "numeric" });
};
